<template>
    <div class="marketing-image">
        <WxOpenBrowserMask v-model="showMask" />
        <div @click="handleClick">
            <img class="image" :style="customStyle" :src="src" />
        </div>
    </div>
</template>

<script>
import { isWx } from '../../../util/report/nioapp-event-report/utils.js';
import { isInNioCNApp, redirectToViewBridge } from '@/util/platform/universal';
import { pushHash } from '@/util/dmp/push-hash';
import WxOpenBrowserMask from './wx-open-browser-mask';

import trackExposeMixin from '../mixin/track-expose';
export default {
    name: 'marketing-image',
    componentName: 'marketingImage',
    mixins: [trackExposeMixin],
    components: { WxOpenBrowserMask },
    props: {
        customStyle: String,
        src: String, // 图片链接
        href: String, // 点击图片跳转链接
        index: Number,
        rootMark: String,
        defaultURL: String, // 未唤起APP时跳转地址
        trackEvent: Function, // 有跳转事件时触发
        trackSelectAction: Function //只要点击就会触发
    },
    data() {
        return {
            showMask: false
        };
    },
    methods: {
        async handleClick() {
            if (this.trackSelectAction) {
                await this.trackSelectAction({ image: this.src });
            }
            if (!this.href) {
                return;
            }
            if (!this.href.startsWith('http') && isWx()) {
                pushHash(
                    encodeURIComponent(
                        JSON.stringify({
                            jump: 'immediate',
                            index: this.index,
                            from: this.rootMark
                        })
                    )
                );
                this.showMask = true;
                return;
            }

            if (this.trackEvent) {
                await this.trackEvent();
            }
            if (!this.href.startsWith('http') && isInNioCNApp()) {
                redirectToViewBridge(this.href);
            } else {
                location.href = this.href;
                if (!this.href.startsWith('http') && !isInNioCNApp()) {
                    // 如果没有唤起app则3秒后会跳转到下载地址，反之则不会跳转到下载地址。
                    setTimeout(() => {
                        window.location.href =
                            this.defaultURL ||
                            'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.weilaihui3'; //下载地址
                    }, 3000);
                }
            }
        }
    },
    beforeMount() {
        this.trackExposeCustom.image = this.src;
    }
};
</script>

<style lang="less" scoped>
.marketing-image {
    width: 100%;
    .image {
        display: flex;
        flex-direction: column;
        width: 100%;
        vertical-align: middle;
        object-fit: cover;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/marketing/components/image.vue